'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
//
// Autogenerated by Thrift Compiler (0.9.3-airbnb12)
//
// DO NOT EDIT UNLESS YOU ARE SURE THAT YOU KNOW WHAT YOU ARE DOING
//
var PropTypes = process.env.NODE_ENV === 'production' ? null : require('prop-types');

/**
 * This acts as a wrapper for events that cannot be serialized to Thrift-encoded binary.
 * JSON serialization tends to be more forgiving, allowing us to recover data from bad events
 * and aids in event loss investigations.
 */
var MalformedEvent = exports.MalformedEvent = {
  defaultProps: {
    schema: 'com.airbnb.jitney.event.logging.Malformed:MalformedEvent:1.0.0'
  },
  propTypes: process.env.NODE_ENV === 'production' ? {} : {
    event_schema: process.env.NODE_ENV === 'production' ? {} : PropTypes.string,
    event_struct_name: process.env.NODE_ENV === 'production' ? {} : PropTypes.string,
    event_json: process.env.NODE_ENV === 'production' ? {} : PropTypes.string,
    errors: process.env.NODE_ENV === 'production' ? {} : PropTypes.arrayOf(PropTypes.string),
    schema: process.env.NODE_ENV === 'production' ? {} : PropTypes.string
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-jitney-schemas/logging_malformed_event_v1.js
// module id = 456
// module chunks = 168707334958949